export default  {
  bindings: {
  },
  controller: 'integrationStatusController',
  template: require('../views/integration.status.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/integration/components/integration.status.component.js